import { Component, Input } from '@angular/core';

@Component({
    selector: 'spinner',
    template: `<div *ngIf="showSpinner">
                   <img src="/assets/shared/images/spinner.gif">
               </div>
    `
})

/**
 * Shared Spinner Widget, to show when loading Ajax requests
 */
export class SpinnerComponent {
    @Input() showSpinner: boolean;
}
